module.exports = __webpack_public_path__ + "img/PayrollInfo.0f381cbc.svg";